import { Container, makeStyles, Typography } from "@material-ui/core";
import { Worker, Viewer } from "@react-pdf-viewer/core";

// Import the styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import BlurBoxBackgroundContainer from "../../component/BlurBoxBackgroundContainer";
import InfoPdf from "./Info.pdf";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "-210px",
    marginBottom: "40px",
    paddingLeft: "40px",
    paddingRight: "40px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "-120px",
      paddingLeft: "10px",
      paddingRight: "10px",
    },
    height: "100%",
  },
  title: {
    paddingBottom: "40px",
  },
  subtitleHeader: {
    [theme.breakpoints.down("sm")]: {
      fontSize: ".75rem",
      letterSpacing: ".60px",
    },
  },
  root: {
    width: "100%",
    // backgroundColor: "rgba(2, 50, 4, 0.6)",
    height: "auto",
    paddingTop: "50px",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "8px",
    },
  },
  pdf: {
    width: "100% !important",
  },
}));
const Information = () => {
  const classes = useStyles();
  return (
    <BlurBoxBackgroundContainer background="aboutPage--background">
      <Container className={classes.container} maxWidth="lg">
        <Typography color="primary" variant="h1" className={classes.title}>
          事業紹介
        </Typography>
        <Typography variant="body1" className={classes.subtitleHeader}>
          私たちは、食をはぐくむ企業です
        </Typography>
        <Container className={classes.root}>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
            <Viewer fileUrl={InfoPdf} />
          </Worker>
        </Container>
      </Container>{" "}
    </BlurBoxBackgroundContainer>
  );
};

export default Information;
